export type MusicReleaseTab = "albums" | "eps" | "singles";

export const MUSIC_RELEASE_TABS: { value: MusicReleaseTab; label: string }[] = [
  { value: "albums", label: "Albums" },
  { value: "eps", label: "EPs" },
  { value: "singles", label: "Singles" },
];

type ReleaseLike = { album_group?: string; total_tracks?: number };

export function releaseMatchesTab(release: ReleaseLike, tab: string | null | undefined): boolean {
  const totalTracks = release?.total_tracks || 0;
  if (tab === "singles") {
    return totalTracks <= 2 && release.album_group !== "appears_on";
  }
  if (tab === "eps") {
    return release.album_group !== "appears_on" && totalTracks > 2 && totalTracks < 7;
  }
  return (
    release.album_group !== "appears_on" &&
    (release.album_group === "album" || release.album_group === "compilation" || totalTracks >= 7)
  );
}

export function releasesForTab<T extends ReleaseLike>(releases: T[] | null | undefined, tab: string | null | undefined): T[] {
  return (releases || []).filter((release) => release && releaseMatchesTab(release, tab));
}

export function availableMusicTabs(releases: ReleaseLike[] | null | undefined): MusicReleaseTab[] {
  return MUSIC_RELEASE_TABS.map((tab) => tab.value).filter((tab) => releasesForTab(releases, tab).length > 0);
}

export type ReleaseKind = "album" | "ep" | "single" | "feature";

export const RELEASE_KIND_LABELS: Record<ReleaseKind, { one: string; many: string }> = {
  album: { one: "Album", many: "Albums" },
  ep: { one: "EP", many: "EPs" },
  single: { one: "Single", many: "Singles" },
  feature: { one: "Feature", many: "Features" },
};

export function releaseKind(release: ReleaseLike): ReleaseKind {
  if (release?.album_group === "appears_on") return "feature";
  const totalTracks = release?.total_tracks || 0;
  if (totalTracks <= 2) return "single";
  if (release.album_group === "album" || release.album_group === "compilation" || totalTracks >= 7) return "album";
  return "ep";
}

export function resolveMusicTab(requested: string | null | undefined, available: MusicReleaseTab[]): MusicReleaseTab | null {
  if (available.length === 0) return null;
  return available.includes(requested as MusicReleaseTab) ? (requested as MusicReleaseTab) : available[0];
}
